import { useEffect, useState } from "react";
import { find, isEmpty, isNil } from "lodash";
import { useParams } from "react-router-dom";

import useWorkflowsStore from "models/workflows/workflows.store";
import CONST from 'utils/constants';
import CommonWorkflowsAppView from "./workflows-app-view";

const { MENU_APP_SOURCES } = CONST;

function WorkflowsPrivateView() { 
  const { dynamicMenu, privateApps } = useWorkflowsStore();
  const [appKey, setAppKey] = useState("");
  const { key: marketplaceKey } = useParams()
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    if (!isNil(dynamicMenu) && !isNil(privateApps) && !isNil(marketplaceKey)) {
      const workflowApp = find(
        [...dynamicMenu || [], ...privateApps || []],
        (app) => app?.appSource === MENU_APP_SOURCES.WORKFLOW && app?.marketplaceKey === marketplaceKey
      );

      if (!isEmpty(workflowApp)) {
        setAppKey(workflowApp?.workflowAppKey);
        setIsLoading(false)
      } else {
        //TODO create not found page
        //props.history.replace('/not-found-page')
      }
    }
  }, [marketplaceKey, dynamicMenu, privateApps]);
  return(
    !isLoading && <CommonWorkflowsAppView appKey={appKey} />
  )
  
}

export default WorkflowsPrivateView;